<template>
<div class="modal fade" ref="modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Complimenti</h5>
            </div>
            <div class="modal-body">
                <template v-if="badge != null">
                    <div class="mb-3 medaglia" col-style="width: 15rem;">
                        <p class="card-text text-center">Hai ottenuto una nuova medaglia</p>
                        <img class="card-img-top" :src="'/assets/img/badge/' + badge.image" :alt="badge.alt">
                    </div>
                </template>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary"
                    @click="onClickNext()">Procedi</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>

import axios from 'axios'

export default {
    name: 'MbBadgeWon',
    props: {
        userId: {
            type: Number
        }
    },
    data() {
        return {
            badgeIndex: 0,
            badges: [],
            badge: null,
            modal: null,
            callback: null
        }
    },
    mounted() {
        this.modal = new window.bootstrap.Modal(this.$refs.modal)
    },
    methods: {
        checkBadges(callback) {
            this.callback = callback
            this.badgeIndex = 0
            this.badges = []

            let url = "/structure/badge/BadgeAction-badgeToNotify?outFormat=json&userId=" + this.userId
            if (!this.userId) {
                url = "/patient/BadgeAction-badgeToNotify?outFormat=json"
            }

            axios.get(url)
                .then(response => {
                    this.badges = response.data
                    if (!this.badges || this.badges.length == 0) {
                        this.callback()
                        return
                    }

                    this.modal.toggle()
                    this.badgeIndex = -1
                    this.onClickNext()
                })
                .catch(error => {
                    console.log(error)
                })
        }, 
        onClickNext(){
            this.badgeIndex++
            if(this.badgeIndex >= this.badges.length){
                this.modal.toggle()
                this.callback()
                return
            }
            
            this.badge = this.badges[this.badgeIndex]
        }
    }
}

</script>